module.exports = __webpack_public_path__ + "img/multiplier_bg.0ae53d81.png";